import React from "react";
import { Typography } from "@avenue-8/sidekick-ui";

export const pMapper = (
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLParagraphElement>,
    HTMLParagraphElement
  >
) => {
  const { children, className, style, id } = props;
  return (
    <Typography variant="body1" className={className} style={style} id={id}>
      {children}
    </Typography>
  );
};

export const spanMapper = (
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLSpanElement>,
    HTMLSpanElement
  >
) => {
  const { children, className, style, id } = props;
  return (
    <Typography
      component="span"
      variant="body2"
      className={className}
      style={style}
      id={id}
    >
      {children}
    </Typography>
  );
};

interface HeadingMapperProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  > {
  level: 1 | 2 | 3 | 4 | 5 | 6;
}

const headingMapper = (props: HeadingMapperProps) => {
  const { children, level, className, style, id } = props;
  const variantMap = {
    1: "h1" as const,
    2: "h2" as const,
    3: "h3" as const,
    4: "h4" as const,
    5: "h5" as const,
    6: "h6" as const,
  };

  return (
    <Typography
      variant={variantMap[level]}
      className={className}
      style={style}
      id={id}
    >
      {children}
    </Typography>
  );
};

export const h1Mapper = (
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  >
) => headingMapper({ ...props, level: 1 });

export const h2Mapper = (
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  >
) => headingMapper({ ...props, level: 2 });

export const h3Mapper = (
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  >
) => headingMapper({ ...props, level: 3 });

export const h4Mapper = (
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  >
) => headingMapper({ ...props, level: 4 });

export const h5Mapper = (
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  >
) => headingMapper({ ...props, level: 5 });

export const h6Mapper = (
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  >
) => headingMapper({ ...props, level: 6 });
